
import React from 'react';
import { Twitter, Linkedin, Facebook, Instagram } from 'lucide-react';

const FooterSocial = () => {
  return (
    <div className="flex items-center gap-4">
      <a
        href="https://twitter.com/scalooai"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-600 hover:text-indigo-600 transition-colors"
        aria-label="Twitter"
      >
        <Twitter className="w-5 h-5" />
      </a>
      <a
        href="https://linkedin.com/company/scalooai"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-600 hover:text-indigo-600 transition-colors"
        aria-label="LinkedIn"
      >
        <Linkedin className="w-5 h-5" />
      </a>
      <a
        href="https://facebook.com/scalooai"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-600 hover:text-indigo-600 transition-colors"
        aria-label="Facebook"
      >
        <Facebook className="w-5 h-5" />
      </a>
      <a
        href="https://instagram.com/scalooai"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-600 hover:text-indigo-600 transition-colors"
        aria-label="Instagram"
      >
        <Instagram className="w-5 h-5" />
      </a>
    </div>
  );
};

export default FooterSocial;
